/** The tabs of a device type's page, by the path segment each is mounted at. */
export enum DeviceTypeTab {
  Devices = "devices",
  Details = "details",
  Configurations = "configurations",
}
